// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GridStrollerItem":"cm_a bht_h","GridStrollerItem--loading":"cm_b","GridStrollerItem__link":"cm_c"};